module.exports = __webpack_public_path__ + "img/ZE.a917c691.png";